import { jwtDecode } from 'jwt-decode';

export interface TokenPayload {
  exp: number;
  sub: string;
  iat?: number;
  [key: string]: unknown;
}

export function isTokenExpired(token: string, bufferSeconds = 30): boolean {
  try {
    const payload = jwtDecode<TokenPayload>(token);
    if (!payload.exp) {
      return true;
    }
    const expiresAt = payload.exp * 1000;
    const now = Date.now();
    const buffer = bufferSeconds * 1000;
    return now > expiresAt - buffer;
  } catch {
    return true;
  }
}

export function getTokenExpiration(token: string): number | null {
  try {
    const payload = jwtDecode<TokenPayload>(token);
    if (!payload.exp) {
      return null;
    }
    return payload.exp * 1000;
  } catch {
    return null;
  }
}

export function parseJwtPayload<T extends TokenPayload>(token: string): T | null {
  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}

export function getTokenTimeRemaining(token: string): number {
  const expiration = getTokenExpiration(token);
  if (!expiration) {
    return 0;
  }

  const remaining = expiration - Date.now();
  return Math.max(0, remaining);
}
